import { ComponentPortal, DomPortalOutlet } from '@angular/cdk/portal';
import { ApplicationRef, ComponentFactoryResolver, Injectable, Injector } from '@angular/core';
import { IModalOptions, ModalTypes } from '../../models/IModalOptions';

import { ModalComponent } from '../../components/modal/modal.component';
import { isObservable } from 'rxjs';
import { IModalController } from '../interfaces/imodal-controller';

@Injectable({
  providedIn: 'root'
})
export class ModalController implements IModalController { 

  private modalPortal: ComponentPortal<ModalComponent>;
  private bodyPortalOutlet: DomPortalOutlet;
  private modalOptions: IModalOptions;
  
  // Utility class to instanciate a modal component
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector 
  ) { 
    this.bodyPortalOutlet = new DomPortalOutlet(
      document.body,
      this.componentFactoryResolver,
      this.applicationRef,
      this.injector
    );

  }

  create(options: IModalOptions) {
    this.modalOptions = options;
    this.modalPortal = new ComponentPortal(ModalComponent);
  }

  present() {
    const componentRef = this.bodyPortalOutlet.attachComponentPortal(this.modalPortal);
    
    if (isObservable(this.modalOptions.title)) {
      this.modalOptions.title.subscribe(
        title => componentRef.instance.title = title
      );
    } else {
      componentRef.instance.title = this.modalOptions.title;
    }
    
    componentRef.instance.titleAlign = this.modalOptions.titleAlign ?? "left";
    componentRef.instance.type    = this.modalOptions.type || ModalTypes.Normal;
    componentRef.instance.content = this.modalOptions.content;
    componentRef.instance.width = this.modalOptions.width ?? 620;
    componentRef.instance.showHeader = this.modalOptions.showHeader ?? true;
    componentRef.instance.padding = this.modalOptions.padding ?? true;
    componentRef.instance.clear   = () => { this.bodyPortalOutlet.detach(); }
    
    if(this.modalOptions.buttons) {
      componentRef.instance.primaryAction   = this.modalOptions.buttons[0];
      componentRef.instance.secondaryAction = this.modalOptions.buttons[1];
    }
    
    componentRef.changeDetectorRef.detectChanges();

    return new Promise(
      resolve => {
        componentRef.instance.selection = resolve
      });
  }
}
